import CustomTable from "@/components/CustomTable/CustomTable.vue";
import IconCard from "@/components/CustomCard/IconCard.vue";
import { format_date } from '@/utils/date_formatter';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';

export default {
  name: 'ViewWorkflow',
  components: {
    CustomTable,
    IconCard
  },
  data: () => ({
    customers: [],
    total_customer_count: 0,
    loading: false,
    columns: [
      {label: 'Customer', key: 'name_email'},
      {label: 'Date Joined', key: 'date_joined'},
    ],
  }),
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    }
  },
  methods: {
    fetch_workflow_customers(page = 1, search = "") {
      const TOKEN = localStorage.getItem("token");
      this.loading = true;
      return new Promise((resolve, reject) => {
        let url = `${API_BASE_URL}/verify_api/workflow_management_api/get_customers_in_workflow/${this.workflow_id}?page=${page}`;
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        $.ajax({
          url: url,
          method: "GET",
          dataType: "json",
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          success: (data) => {
            this.customers = data.results;
            this.total_customer_count = data.count || parseInt(localStorage.getItem('total_customers') || 0);
            localStorage.setItem('total_customers', this.total_customer_count);
            resolve({ count: data.count, results: data.results });
            this.loading = false;
          },
          error: function (xhr, status, error) {
            if (xhr.responseJSON && xhr.responseJSON.detail === "Invalid page.") {
              localStorage.setItem('page_workflow_customers', '1');
              this.loading = false;
              return this.fetch_workflow_customers(1, search).then(resolve).catch(reject);
            } else {
              reject(error);
              this.loading = false;
            }
          }.bind(this)
        });
      });
    },

    formatDate(date) {
      return format_date(date);
    },

    view_customer_applications(customer_id) {
      this.$router.push({ name: 'customer_applications', params: { id: customer_id } });
    },
  },
  async mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    this.fetch_workflow_customers();
  },
};

